const map = {
	"./Ice-Arena-photo.jpg": 779,
	"./balance.jpg": 319,
	"./bendy.jpg": 673,
	"./chantelle-coach-licence.jpg": 882,
	"./chantelle-ice-skating-coach-hero.jpg": 317,
	"./chantelle-ice-skating-lessons.jpg": 283,
	"./chantelle2.jpg": 875,
	"./chantelle3.jpg": 414,
	"./colourful.jpg": 170,
	"./elephant.jpg": 816,
	"./grinch.jpg": 72,
	"./group.jpg": 134,
	"./iceshow.jpg": 437,
	"./iceshowmonkey.jpg": 466,
	"./manystudents.jpg": 426,
	"./megasparkles.jpg": 932,
	"./podium1.jpg": 690,
	"./podium2.jpg": 597,
	"./showgear.jpg": 85,
	"./skates.jpg": 726,
	"./smile.jpg": 695,
	"./sparkles.jpg": 878,
	"./sparkleswhoosh.jpg": 996,
	"./student.jpg": 70,
	"./studentpodium.jpg": 822,
	"./students.jpg": 603,
	"./twostudent.pg.jpg": 483,
	"./whitesparkles.jpg": 573,
	"./youngstudent.jpg": 6,
	"./youngstudents.jpg": 667,
	"./zoomies.jpg": 449
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 489;